export default __webpack_public_path__ + "static/media/facebook.6f461da8.jpg";